export default {
  API_RESOURCE: 'activities',
  PROJECT_PATH: 'project',
  DASHBOARD_PATH: 'dashboard'
}
